import { Component, Inject, ViewChild, TemplateRef, ChangeDetectorRef, ViewRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '@app/core/services/UserService';
import { Observable } from 'rxjs';
//import { ServiceService } from '@app/core/services/ServiceService';
import { AuthenticationService } from '@app/core/services/AuthenticationService';
import { OrganizationService } from '@app/core/services/OrganizationService';
import { ICompany } from '@app/core/interfaces/ICompany';
//import { InvoiceService } from '@app/core/services/InvoiceService';
import { CompanyService } from '@app/core/services/CompanyService';
import { UntypedFormControl } from '@angular/forms';
import { IAccountSettings } from '@app/core/interfaces/user/IAccountSettings';
import { NgForm } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'edit-customer-dialog',
  templateUrl: 'EditCustomerDialog.Component.html',
  styleUrls: ['EditCustomerDialog.Component.scss']
})
export class EditCustomerDialogComponent {
  private _dimesionToggle = false;
  private _formValid = false;
  public _imageList: any[] = [];
  public _hasImages = false;
  private _showImageList = false;
  private _showAttachments = false;
  private _hasAttachments = false;
  private _showComments = false;
  private _isCompany = false;
  public _isPrivatePerson = true;
  public customer: ICompany;
  public isNewCustomer: boolean;
  @ViewChild('myInput', { static: false })
  myInputVariable: any;
  private _apiBaseUrl: string;
  countries: any[] = [];
  orgNumberPattern = "^[0-9]{6}-[0-9]{4}$";
  pNumberPattern = "^[0-9]{6}-[0-9]{4}$";
  emailPattern = "[A-Öa-ö0-9._%+-]+@[A-Öa-ö0-9.-]+\.[A-Öa-ö]{1,63}$";
  isAdmin: boolean = false;
  orgNumberValid: boolean = false;
  pNrValid: boolean = false;
  isSearchingCompany: boolean = false;
  companySearchFailed: boolean = false;
  isSearchingPerson: boolean = false;
  phoneNumberValid: boolean = true;
  errorMessage: string = "";
  searchCompleted: boolean = false;
  customerSearchTerm: string;
  filteredCustomers: Observable<any[]>;
  selectedCustome: any;
  selectedCustomerObject: any;
  selectedCustomerName: any;
  public searchAccountValue: string;
  customeSearchTerm: string;
  customers: Customer[] = [];
  userCtrl: UntypedFormControl;
  searchAccountResult: any;
  searchByOrgNrCompleted: boolean = false;
  InvoiceSendTypeLocked = false;
  paymentTerms = [0, 10, 15, 20, 25, 30, 45, 60];
  errorMessageOrgnr: string = '';
  errorMessagePnr: string = '';
  errorMessagePhoneNr: string = '';
  currentUserOrganizationId: number = 0;
  noResultMessage = "";
  companyIsActive: boolean = false;
  errorMessageSpar: string = "";
  private lastCountryId: number = null;
  countrySelectionLocked: boolean = false;
  @ViewChild('personForm', { static: true }) personForm: NgForm;

  constructor(
    public dialogRef: MatDialogRef<EditCustomerDialogComponent>,
    private userService: UserService,
    private organizationService: OrganizationService,
    private authenticationService: AuthenticationService,
    private companyService: CompanyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  private queueDetectChanges(): void {
    const viewRef = this.changeDetectorRef as ViewRef;
    if (!viewRef.destroyed) {
      setTimeout(() => {
        const vr = this.changeDetectorRef as ViewRef;
        if (!vr.destroyed) {
          this.changeDetectorRef.detectChanges();
        }
      }, 0);
    }
  }

  private deferUiUpdate(action: () => void): void {
    setTimeout(() => {
      const vr = this.changeDetectorRef as ViewRef;
      if (!vr.destroyed) {
        action();
        this.changeDetectorRef.detectChanges();
      }
    }, 0);
  }

  ngOnInit() {
    this.dialogRef.addPanelClass('customer-edit-panel');
    this.dialogRef.updateSize('840px', 'auto');
    const organizationIdFromDialog = Number(this.data && this.data.organizationId ? this.data.organizationId : 0);
    this.currentUserOrganizationId = organizationIdFromDialog > 0
      ? organizationIdFromDialog
      : (this.authenticationService.getCurrentUserOrganization() != null ? this.authenticationService.getCurrentUserOrganization().Id : 0);
    this.isAdmin = this.userService.userHasRole("admin");
    this._isPrivatePerson = true;

    if (this.data.customer != undefined && this.data.customer.Id != undefined && this.data.customer.Id > 0) {
      this.customer = JSON.parse(JSON.stringify(this.data.customer));
    } else if (this.data.Id != undefined) {
      this.customer = JSON.parse(JSON.stringify(this.data));
    } else {
      this.customer = JSON.parse(JSON.stringify(this.data.customerTemplate));
    }
    if (this.customer.PublicInfo === undefined) {
      this.customer.PublicInfo = null;
    }

    // Ensure customer.Country object exists
    if (!this.customer.Country) {
      this.customer.Country = { Id: 1 } as any;
    } else if (!this.customer.Country.Id) {
      this.customer.Country.Id = 1;
    }
    this.lastCountryId = this.customer.Country.Id;

    // Load countries after customer set
    this.getCountries();

    this.isNewCustomer = (this.customer == undefined || this.customer.Id == 0) ? true : false;
    this.countrySelectionLocked = !this.isNewCustomer
      && this.customer.Country.Id === 1
      && new RegExp(this.orgNumberPattern).test(this.customer.OrgNumber || '');

    if (this.isNewCustomer) {
      this.customer.AcceptsInvoiceFee = true;
      this.customer.InvoiceSendType = 0;
      this.customer.IsCompany = true;
      this.customer.Active = true;
      this.customer.ActiveInList = true;
    }

    if (this.customer.InvoiceSendType != 0) {
      this.InvoiceSendTypeLocked = true;
    }

    if (!this.isNewCustomer) {
      if (this.customer.IsCompany) {
        this.orgNumberValidCheck(this.customer.OrgNumber);
      } else {
        this.pNumberValidCheck(this.customer.OrgNumber);
      }
    }

    console.log(this.customer);
  }

  save(customer: ICompany) {
    if (this.currentUserOrganizationId > 0) {
      if (customer.Id == undefined || customer.Id == 0) {
        this.organizationService.createCustomer(this.currentUserOrganizationId, customer)
          .subscribe(value => this.onAfterRowSaved(value), error => this.onError(error));
      } else {
        this.organizationService.updateCustomer(this.currentUserOrganizationId, customer)
          .subscribe(value => this.onAfterRowSaved(value), error => this.onError(error));
      }
    } else {
      if (customer.Id == undefined || customer.Id == 0) {
        this.companyService.createCompany(customer)
          .subscribe(value => this.onAfterRowSaved(value), error => this.onError(error));
      } else {
        this.companyService.updateCompany(customer)
          .subscribe(value => this.onAfterRowSaved(value), error => this.onError(error));
      }
    }
  }

  getCountries() {
    this.companyService.getCountries()
      .subscribe(
        value => {
          setTimeout(() => {
            this.countries = value;
            // initialize country from loaded list using the new handler
            if (this.customer && this.customer.Country && this.customer.Country.Id) {
              this.onCountryChange(this.customer.Country.Id, false);
            }
            const viewRef = this.changeDetectorRef as ViewRef;
            if (!viewRef.destroyed) {
              this.changeDetectorRef.detectChanges();
            }
          }, 0);
        },
        error => this.onError(error)
      );
  }

  getCountryName(countryId: number) {
    if (!this.countries || this.countries.length === 0) return;
    for (var i = 0; i < this.countries.length; i++) {
      if (this.countries[i].Id == countryId) {
        if (!this.customer.Country) this.customer.Country = {} as any;
        this.customer.Country.Name = this.countries[i].Name;
        this.customer.Country.Eu = !!this.countries[i].Eu;
        this.customer.Country.VatRegexPattern = this.countries[i].VatRegexPattern;
        this.customer.Country.VatDescription = this.countries[i].VatDescription;
        break;
      }
    }
  }

  // New handler wired from template when country select changes
  onCountryChange(countryId: number, resetFields: boolean = true) {
    if (this.countrySelectionLocked && this.lastCountryId !== countryId) {
      this.customer.Country.Id = this.lastCountryId;
      return;
    }

    if (this.lastCountryId === countryId) {
      return;
    }
    this.lastCountryId = countryId;

    // Reset company-specific information when changing country
    if (this.customer && resetFields) {
      // Clear search and validation state
      this.searchAccountValue = null;
      this.searchAccountResult = null;
      this.companySearchFailed = false;
      this.selectedCustomerObject = null;
      this.noResultMessage = '';
      this.orgNumberValid = false;
      this.companyIsActive = false;

      // Clear company fields
      this.customer.OrgNumber = null;
      this.customer.Name = null;
      this.customer.NameLocked = false;
      this.customer.Address = null;
      this.customer.AddressLocked = false;
      this.customer.Address2 = null;
      this.customer.Address2Locked = false;
      this.customer.Zip = null;
      this.customer.ZipLocked = false;
      this.customer.City = null;
      this.customer.CityLocked = false;
      this.customer.Phone = null;
      this.customer.PhoneLocked = false;
      this.customer.InvoiceEmail = null;
      this.customer.InvoiceEmailLocked = false;
      this.customer.Co = null;
      this.customer.CoLocked = false;
      this.customer.PaymentTerm = 0;
      this.customer.PaymentTermLocked = false;
      this.customer.GlnNumber = null;
      this.customer.GlnNumberLocked = false;
      this.customer.InvoiceSendType = 0;
      this.customer.InvoiceSendTypeLocked = false;
      this.customer.AcceptsInvoiceFee = true;
      this.customer.AcceptsInvoiceFeeLocked = false;

      // reset personal-number validation state if relevant
      this.pNrValid = false;
    }

    if (!this.countries || this.countries.length === 0) return;
    const found = this.countries.find(c => c.Id == countryId);
    if (found) {
      if (!this.customer.Country) this.customer.Country = {} as any;
      this.customer.Country.Id = found.Id;
      this.customer.Country.Name = found.Name;
      this.customer.Country.Eu = !!found.Eu;
      this.customer.Country.VatRegexPattern = found.VatRegexPattern;
      this.customer.Country.VatDescription = found.VatDescription;
      this.customer.Country.VatPlaceholder = found.VatPlaceholder;
      this.customer.Country.VatErrorMessage = found.VatErrorMessage;
    } else {
      if (!this.customer.Country) this.customer.Country = {} as any;
      this.customer.Country.Id = countryId;
      this.customer.Country.Name = '';
      this.customer.Country.Eu = false;
      this.customer.Country.VatRegexPattern = '';
      this.customer.Country.VatDescription = '';
      this.customer.Country.VatPlaceholder = '';
      this.customer.Country.VatErrorMessage = '';
    }

    // After changing country, re-run org number validation (will accept empty for non-Sweden without pattern)
    this.orgNumberValidCheck(this.customer.OrgNumber);
  }

  getErrorMessage() {
    // placeholder
  }

  cancel() {
    this.dialogRef.close(undefined);
  }

  onError(error: any) {
    alert('An error occured');
    console.log(error);
  }

  onAfterRowSaved(response: ICompany) {
    this.dialogRef.close(response);
  }

  customerTypeToggle(isCompany: boolean) {
    this.customer.IsCompany = isCompany;
  }

  customerSelected(event: any) {
    this.getCustomerData(event.option.value);
    this.customerSearchTerm = null;
  }

  getCustomerData(orgNumber: number) {
    this.companyService.getGlobalCompanyByOrgNr(orgNumber.toString())
      .subscribe(response => this.getCustomerDataFinished(response), error => console.log(error));
  }

  getCustomerDataFinished(response: any) {
    if (response.length > 0) this.selectedCustomerObject = response[0];
  }

  get orgNumberFormat(): string {
    const country = this.customer && this.customer.Country;
    return country && (country.VatDescription || country.VatPlaceholder ||
      ((country.Name === 'Sverige' || country.Id === 1) ? 'NNNNNN-NNNN (10 siffror och bindestreck)' : '')) || '';
  }

  orgNumberValidCheck(orgNumber: string, showFormatError: boolean = false) {
    this.companySearchFailed = false;
    // Start in invalid state
    this.orgNumberValid = false;
    this.errorMessageOrgnr = '';
    this.noResultMessage = '';

    // If input is empty, only accept it when the selected country is NOT Sweden and no VatRegexPattern is configured
    if (!orgNumber) {
      if (this.customer && this.customer.Country) {
        const country = this.customer.Country;
        const isSweden = country.Name === 'Sverige' || country.Id === 1;
        const pattern = country.VatRegexPattern;
        if (!isSweden && (!pattern || pattern.toString().trim() === '')) {
          // Allow empty org number for non-Swedish countries without pattern
          this.orgNumberValid = true;
          // keep stored OrgNumber as null/empty
          if (this.customer) this.customer.OrgNumber = null;
          return;
        }
      }

      // empty input -> remain invalid
      if (this.customer) this.customer.OrgNumber = null;
      return;
    }

    const value = (orgNumber || '').trim();
    const country = this.customer && this.customer.Country ? this.customer.Country : null;

    if (!country) {
      // No country selected -> cannot perform country-specific validation
      // Keep invalid to force selection, but store value
      if (this.customer) this.customer.OrgNumber = value;
      return;
    }

    const isSweden = country.Name === 'Sverige' || country.Id === 1;

    // If no pattern is configured and country is NOT Sweden, accept the input as valid
    const pattern = country.VatRegexPattern;
    if ((!pattern || pattern.toString().trim() === '') && !isSweden) {
      this.orgNumberValid = true;
      if (this.customer) this.customer.OrgNumber = value;
      return;
    }

    // If we reach here and no pattern exists (Sweden case), fall back to default Swedish pattern
    let regex: RegExp | null = null;
    if (!pattern || pattern.toString().trim() === '') {
      // fallback Swedish pattern
      regex = /^[0-9]{6}-[0-9]{4}$/;
    } else {
      try {
        regex = new RegExp(pattern);
      } catch (e) {
        console.error('Invalid VatRegexPattern for country', country, e);
        this.errorMessageOrgnr = 'Tekniskt fel i valideringsregeln för detta land. Kontakta support.';
        return;
      }
    }

    if (!regex.test(value)) {
        if (showFormatError || (isSweden && value.replace(/\D/g, '').length >= 10)) {
          this.errorMessageOrgnr = this.orgNumberFormat
            ? 'Ange organisationsnumret i formatet: ' + this.orgNumberFormat
            : 'Numret matchar inte förväntat format för valt land.';
        }
      return;
    }

    // Pattern matched
    if (isSweden && this.isNewCustomer) {
      // For Sweden new customers require API verification
      this.noResultMessage = '';
      this.GetCompanyByOrgNr(value);
      // orgNumberValid will be set true in callback when company is found
    } else {
      // Other countries or existing Swedish customers: accept
      this.orgNumberValid = true;
    }

    if (this.customer) this.customer.OrgNumber = value;
  }


  pNumberValidCheck(pNumber: string) {
    if (pNumber == null) {
      return;
    }

    // Remove non-digit characters
    const digits = (pNumber || '').replace(/[^0-9]/g, '');

    // Helper to infer century for 10-digit numbers (YYMMDDNNNN -> YYYYMMDDNNNN)
    function to12Digits(d10: string): string | null {
      if (d10.length !== 10) return null;
      const yy = parseInt(d10.substr(0, 2), 10);
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentYY = currentYear % 100;

      // If yy > currentYY assume 1900s, else 2000s
      const century = yy > currentYY ? 1900 : 2000;
      return (century + yy).toString() + d10.substr(2);
    }

    // If country not set or not Sweden, accept
    const country = this.customer && this.customer.Country ? this.customer.Country : null;
    const isSweden = country && (country.Name === 'Sverige' || country.Id === 1);

    if (!isSweden) {
      this.pNrValid = true;
      this.customer.OrgNumber = pNumber;
      this.errorMessageOrgnr = '';
      return;
    }

    // Sweden: accept either 12-digit (YYYYMMDDNNNN) or 10-digit (YYMMDDNNNN)
    if (digits.length === 12) {
      this.errorMessagePnr = '';
      this.isSearchingPerson = true;
      this.GetPersonByPersonalNumber(digits);
      return;
    }

    if (digits.length === 10) {
      const d12 = to12Digits(digits);
      if (d12) {
        this.errorMessagePnr = '';
        this.isSearchingPerson = true;
        this.GetPersonByPersonalNumber(d12);
        return;
      }
    }

    // Otherwise invalid format
    this.errorMessagePnr = "Personnumret måste vara i formatet ÅÅÅÅMMDDNNNN eller YYMMDDNNNN";
    this.errorMessageSpar = "";
    this.customer.AdminInfo = "";
    this.pNrValid = false;
  }

  phoneNumberValidCheck(phoneNumber: string) {
    if (phoneNumber != null && phoneNumber != "") {
      const value: string = phoneNumber || '';
      if (value.match(/^[0-9+-]*$/g)) {
        this.phoneNumberValid = true;
        this.errorMessagePhoneNr = "";
      } else {
        this.errorMessagePhoneNr = "Telefonnummer får bara innehålla siffror, vanligt bindestreck och plustecken";
        this.phoneNumberValid = false;
      }
      this.customer.Phone = phoneNumber;
    } else {
      this.phoneNumberValid = true;
      this.customer.Phone = phoneNumber;
      this.errorMessageOrgnr = "";
    }
  }

  GetCompanyByOrgNr(term: string) {
    if (!term) {
      return;
    }

    // Visa gärna att vi håller på att slå upp
    this.orgNumberValid = false;
    this.errorMessageOrgnr = '';
    this.noResultMessage = '';
    this.isSearchingCompany = true;
    this.companySearchFailed = false;

    this.companyService.getGlobalCompanyByOrgNr(term)
      .subscribe({
        next: (response) => {
          // Hittade bolag → behandla som tidigare
          this.deferUiUpdate(() => {
            this.onSearchAccountCompleted(response, term);
            this.orgNumberValid = true;
            this.errorMessageOrgnr = '';
            this.isSearchingCompany = false;
          });
        },
        error: (error) => {
          console.error('GetCompanyByOrgNr failed', error);

          this.deferUiUpdate(() => {
            this.isSearchingCompany = false;
            // Om API:t använder 404 för "inget bolag hittat"
            if (error.status === 404) {
              this.onSearchAccountCompleted(null, term);
              this.errorMessageOrgnr = '';
            } else {
              // Tekniskt fel (nätverk, 500, etc)
              this.companySearchFailed = true;
              this.orgNumberValid = false;
              this.errorMessageOrgnr =
                'Inget företag kunde hittas på detta organisationsnummer.';
              this.noResultMessage = '';
            }
          });
        }
      });
  }


  GetPersonByPersonalNumber(term: string) {
    if (term == null || term == "") {
      return;
    }
    term = term.replace("-", "");
    this.isSearchingPerson = true;
    this.userService.getPersonFromSparByPersonalNumber(term)
      .subscribe({
        next: (response) => {
          this.onGetPersonFromSparCompleted(response, term);
          this.isSearchingPerson = false;
        },
        error: (err) => {
          this.isSearchingPerson = false;
          this.onGetPersonFromSparError(err);
        }
      });
  }

  onGetPersonFromSparError(error) {
    console.error('onGetPersonFromSparError', error);
    this.deferUiUpdate(() => {
      this.isSearchingPerson = false;
    });
    alert('Err')
  }

  onGetPersonFromSparCompleted(response, term) {
    // ensure spinner cleared
    this.isSearchingPerson = false;

    try {
      if (response && response.hits == 1) {
        this.customer.OrgNumber = term
        var notInSpar = false;
        if (response.firstName == "" || response.lastName == "") {
          notInSpar = true;
        }
        this.customer.Name = response.firstName + " " + response.lastName;
        this.customer.NameLocked = true;
        this.customer.Address = response.address;
        this.customer.AddressLocked = true;
        this.customer.Zip = response.zip;
        this.customer.ZipLocked = true;
        this.customer.City = response.city;
        this.customer.CityLocked = true;
        this.pNrValid = true;
        this.errorMessageSpar = "";
        this.customer.AdminInfo = "";
        if (notInSpar) {
          this.customer.NameLocked = false;
          this.customer.AddressLocked = false;
          this.customer.ZipLocked = false;
          this.customer.CityLocked = false;
          this.customer.AdminInfo = "Personnr korrekt men finns ej hos SPAR, info anges manuellt";
        }
      }
      else if (response && response.hits == 0) {
        this.errorMessageSpar = "";
        this.customer.AdminInfo = "";
        this.pNrValid = true;
      }
      else {
        this.errorMessageSpar = "Vi hittar ingen person med detta personnummer, kontrollera att personnumret är korrekt";
        this.customer.AdminInfo = "";
        this.pNrValid = false;
        if (this.isAdmin) {
          this.pNrValid = true;
        }
      }
    } catch (e) {
      console.error('Error handling SPAR response', e, response);
      this.pNrValid = false;
      this.errorMessageSpar = 'Fel vid tolkning av SPAR-svar.';
    }
    this.queueDetectChanges();
  }

  onSearchAccountCompleted(response: ICompany, term) {
    this.searchAccountResult = response;
    if (this.searchAccountResult != null) {
      this.updateCustomerInfo(this.searchAccountResult);
      this.noResultMessage = "";
      this.orgNumberValid = true;
      this.companyIsActive = this.searchAccountResult.Active;
      if (!this.companyIsActive)
        alert('Det org.nr. du angett har status inaktivt, konkurs eller annat som gör att vi inte kan hitta dess data. Är du säker på att organisationsnumret är korrekt så kontakta supporten genom att maila support@samgruppen.se så återkommer vi så snart vi kan');
    } else {
      this.noResultMessage = "Detta organisationsnummer finns inte registrerad hos Bolagsverket. Det kan hända för t ex ideella föreningar. Om du är säker på att organisationsnumret är korrekt kan du ange din kunds uppgifter nedan:";
      this.orgNumberValid = true;
      this.customer.OrgNumber = term;
      this.companyIsActive = false;
    }
  }

  formValid() {
    if (this.isAdmin) return true;

    // If country is non-Sweden and no VatRegexPattern -> allow saving when basic fields are present
    const country = this.customer && this.customer.Country ? this.customer.Country : null;
    const isSweden = country && (country.Name === 'Sverige' || country.Id === 1);
    const hasVatPattern = country && country.VatRegexPattern && country.VatRegexPattern.toString().trim() !== '';

    if (this.customer.IsCompany && country && !isSweden && !hasVatPattern) {
      // require Name, Address, Zip and City
      if (this.customer.Name && this.customer.Address && this.customer.Zip && this.customer.City && this.customer.Active) {
        return true;
      }
      return false;
    }

    if (this.customer.IsCompany && !this.customer.Active) return false;
    if (this.customer.IsCompany && this.isNewCustomer && this.orgNumberValid && this.customer.Active) return true;
    if (this.customer.IsCompany && !this.isNewCustomer && this.customer.Active) return true;
    if (!this.customer.IsCompany && this.personForm.valid) return true;
    if (!this.pNrValid && !this.orgNumberValid) return false;
    if (!this.orgNumberValid && !(this.searchAccountResult && this.searchAccountResult.Active)) return false;
    return false;
  }

  IsCompanyOnChange(customer, isCompany) {
    this.companySearchFailed = false;
    this.pNrValid = false;
    this.orgNumberValid = false;
    customer.IsCompany = isCompany;
    this.searchAccountValue = null;
    customer.NameLocked = false;
    customer.OrgNumber = null;
    customer.Name = null;
    customer.NameLocked = false;
    customer.Address = null
    customer.AddressLocked = false;
    customer.Zip = null
    customer.ZipLocked = false;
    customer.City = null
    customer.CityLocked = false;
    customer.OrgNumber = null;
  }

  updateCustomerInfo(globalCompany: ICompany) {
    this.customer.OrgNumber = globalCompany.OrgNumber;
    this.customer.Active = globalCompany.Active;
    this.customer.InvoiceEmail = "";
    this.customer.PaymentTerm = 0;
    this.customer.Address = "";
    this.customer.Address2 = "";
    this.customer.Zip = "";
    this.customer.City = "";
    this.customer.InvoiceSendType = 0;
    this.customer.PublicInfo = globalCompany.PublicInfo;

    // Copy country info if provided by globalCompany
    if (globalCompany.Country) {
      this.customer.Country = {
        Id: globalCompany.Country.Id,
        Name: globalCompany.Country.Name,
        Eu: globalCompany.Country.Eu,
        VatRegexPattern: globalCompany.Country.VatRegexPattern,
        VatDescription: globalCompany.Country.VatDescription
      } as any;
    }

    if (globalCompany.Name != null && globalCompany.Name != "") {
      this.customer.Name = globalCompany.Name;
      if (globalCompany.Global) {
        this.customer.NameLocked = true;
      }
    }

    if (globalCompany.PaymentTerm != null && globalCompany.PaymentTerm > 0) {
      this.customer.PaymentTerm = globalCompany.PaymentTerm;
      this.customer.PaymentTermLocked = true;
    }

    if (globalCompany.Phone != null && globalCompany.Phone != "") {
      this.customer.Phone = globalCompany.Phone;
      this.customer.PhoneLocked = true;
    }

    if (globalCompany.InvoiceEmail != null && globalCompany.InvoiceEmail != "") {
      this.customer.InvoiceEmail = globalCompany.InvoiceEmail;
      this.customer.InvoiceEmailLocked = true;
    }

    if (globalCompany.Co != null && globalCompany.Co != "") {
      this.customer.Co = globalCompany.Co;
      this.customer.CoLocked = true;
    }

    if (globalCompany.Address != null && globalCompany.Address != "") {
      this.customer.Address = globalCompany.Address;
      if (globalCompany.Global) {
        this.customer.AddressLocked = true;
      }
    }

    if (globalCompany.Address2 != null && globalCompany.Address2 != "") {
      this.customer.Address2 = globalCompany.Address2;
      this.customer.Address2Locked = true;
    }

    if (globalCompany.Zip != null && globalCompany.Zip != "") {
      this.customer.Zip = globalCompany.Zip;
      if (globalCompany.Global) {
        this.customer.ZipLocked = true;
      }
    }

    if (globalCompany.City != null && globalCompany.City != "") {
      this.customer.City = globalCompany.City;
      if (globalCompany.Global) {
        this.customer.CityLocked = true;
      }
    }

    if (globalCompany.GlnNumber != null && globalCompany.GlnNumber != "") {
      this.customer.GlnNumber = globalCompany.GlnNumber;
      this.customer.GlnNumberLocked = true;
    }

    if (globalCompany.InvoiceSendType != 0) {
      this.customer.InvoiceSendType = globalCompany.InvoiceSendType;
      this.customer.InvoiceSendTypeLocked = true;
    } else if (globalCompany.InvoiceSendType == null) {
      this.customer.InvoiceSendType = 0;
    }

    if (globalCompany.AcceptsInvoiceFee == false) {
      this.customer.AcceptsInvoiceFee = false;
      this.customer.AcceptsInvoiceFeeLocked = true;
    }

    this.customer.TimeReportMandatory = globalCompany.TimeReportMandatory;

    this.customer.ElectronicReference = globalCompany.ElectronicReference;
  }

}

export class Customer {
  constructor(public name: string) { }
}
